import type { InfiniteData } from '@tanstack/react-query';

import { flatQueryPages } from '@repo/lib/flatQueryPages';
import { useMemo } from 'react';

export function useInfiniteQueryResult<TData>(data: InfiniteData<TData[], unknown> | undefined, searchValue = '') {
  return useMemo(() => {
    if (!data) {
      return { data: [], isEmpty: true, noResults: false };
    }
    const flatData = flatQueryPages(data);
    const isEmpty = flatData.length === 0 && searchValue.length === 0;
    const noResults = flatData.length === 0 && searchValue.length > 0;
    return { data: flatData, isEmpty: isEmpty, noResults: noResults };
  }, [data, searchValue]);
}
